import { useTheme } from '@/features/theme/contexts/ThemeContext';
import { FiSun } from 'react-icons/fi';
import { RiAliensFill } from 'react-icons/ri';
import { GiCyberEye } from 'react-icons/gi';
import { BsCircleFill } from 'react-icons/bs';

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();

  const getThemeIcon = (themeName: string) => {
    switch (themeName) {
      case 'light':
        return <FiSun className="w-5 h-5" />;
      case 'cyberpunk':
        return <GiCyberEye className="w-5 h-5" />;
      case 'synthwave':
        return <RiAliensFill className="w-5 h-5" />;
      case 'black':
        return <BsCircleFill className="w-5 h-5" />;
      default:
        return <BsCircleFill className="w-5 h-5" />;
    }
  };

  const getThemeTitle = (themeName: string) => {
    switch (themeName) {
      case 'light':
        return 'Light Mode';
      case 'cyberpunk':
        return 'Cyberpunk';
      case 'synthwave':
        return 'Synthwave';
      case 'black':
        return 'Black';
      default:
        return 'Theme';
    }
  };

  return (
    <div className="dropdown dropdown-end">
      <div tabIndex={0} role="button" className="btn btn-ghost btn-circle btn-sm sm:btn-md">
        {getThemeIcon(theme)}
      </div>
      <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow-lg bg-base-200 rounded-box w-52">
        {['black', 'light', 'cyberpunk', 'synthwave'].map((themeName) => (
          <li key={themeName}>
            <button
              onClick={() => setTheme(themeName as any)}
              className={`flex items-center gap-2 ${theme === themeName ? 'active' : ''}`}
            >
              {getThemeIcon(themeName)}
              <span>{getThemeTitle(themeName)}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
} 